import { useTranslation } from 'react-i18next'

import { FormikField } from '../../Formik'
import { InputField } from '../../Input'

import {
  NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_MAX_LENGTH,
  NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME,
} from './NewsboardPostProfileHeaderEditPostAgeField.constants'

function NewsboardPostProfileHeaderEditPostAgeField(props) {
  const { t } = useTranslation()

  return (
    <FormikField
      {...props}
      autoFocus
      clearable
      Component={InputField}
      label={t('NewsboardPostProfile.HeaderPostAgeLabelKey')}
      maxLength={NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_MAX_LENGTH}
      name={NEWSBOARD_POST_PROFILE_EDIT_POST_AGE_FIELD_NAME}
      placeholder={t('NewsboardPostProfile.EditPostAgeFieldPlaceholderKey')}
    />
  )
}

export default NewsboardPostProfileHeaderEditPostAgeField
